export default {
  zh: {
    aboutUs: '关于我们',
    terms: '隐私政策',
    privacyService: '服务条款',
    userAgreement: '用户协议',
    affiliate: '我要加盟',
    download: '下载',
    help: '帮助',
    faq: '常见问题',
    joinUs: '加入我们',
    copyRight: '©2017 Plex Inc. 保留所有权利 ',
    contactUs: '联系我们',
    warning: '严正声明：本网站仅提供网络加速技术服务，严禁从事任何违反您所在国家地区以及服务器所在地法律法规的行为！',
    allRight:'©2017 Plex Inc. All Rights Reserved. '
  },
  en: {
    aboutUs: 'About Us',
    terms: 'Privacy Policy',
    privacyService: 'Terms of Service',
    userAgreement: 'User Agreement',
    affiliate: 'Affiliate',
    download: 'Download',
    help: 'Help',
    faq: 'FAQ',
    joinUs: 'Join Us',
    copyRight: '©2017 Plex Inc. All Rights Reserved. ',
    contactUs: 'Contact Us',
    warning: 'PlexVPN is not a service to be used for criminal acts. It is an Internet security and acceleration service. It  is  prohibited to violate  any  law of any jurisdiction that you are originating from and the law of the server located by PlexVPN.',
    allRight:'©2017 Plex Inc. All Rights Reserved. '
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/lang.js